import { render, staticRenderFns } from "./TrackControls.vue?vue&type=template&id=3dff178e&"
import script from "./TrackControls.vue?vue&type=script&lang=js&"
export * from "./TrackControls.vue?vue&type=script&lang=js&"
import style0 from "./TrackControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports